<template>
<div>
    <validation-observer v-slot="{ invalid }">
        <b-form @submit.prevent="SimpanMaklumat" style="width:1000px;">
            <h3 class="mb-0">MAKLUMAT URUSAN PERTUKARAN PELANTIKAN</h3>
            <br />
            <div class="pl-lg-2">
                <validation-provider name="Klasifikasi Perkhidmatan" :rules="{ required: true }">
                    <b-row>
                        <b-col lg="3"> Klasifikasi Perkhidmatan Tukar Lantik * </b-col>
                        <b-col lg="1"> :</b-col>
                        <b-col lg="4">
                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="Obj.ServClassId" :options="ServClassList" @change="runMethod()" style="width: 100%" aria-describedby="input-2-live-feedback">
                                <template #first>
                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Skim Perkhidmatan Tukar Lantik" :rules="{ required: true }">
                    <b-row>
                        <b-col lg="3"> Skim Perkhidmatan Tukar Lantik *</b-col>
                        <b-col lg="1"> :</b-col>
                        <b-col lg="6">
                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="Obj.SchmOfServId" :options="SchmOfServList" style="width: 100%" aria-describedby="input-2-live-feedback">
                                <template #first>
                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </validation-provider>
                <b-row class="my-1">
                    <b-col sm="1">&nbsp;</b-col>
                </b-row>
                <validation-provider name="pilih skim" :rules="{ required: true }">
                    <b-row>
                        <b-col lg="3" class="font-weight-bold"> Sistem Saraan * </b-col>
                        <b-col lg="1"> :</b-col>
                        <b-col lg="6">
                            <b-form-select id="Pilih Skim" name="Pilih Skim" value-field="value" text-field="text" :options="skimOptions" v-model="Obj.id_SistemSaraan" @change="runMethod2()" style="width: 45%" aria-describedby="input-2-live-feedback">
                                <template #first>
                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Gred Jawatan Tukar Lantik" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col lg="3"> Gred Jawatan Tukar Lantik* </b-col>
                        <b-col lg="1">:</b-col>
                        <b-col lg="6">
                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="Obj.SalGrdID" :options="SalGrdList" style="width: 40%" aria-describedby="input-2-live-feedback">
                                <template #first>
                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Amaun Gaji Tukar Lantik" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col lg='3'>Amaun Gaji Tukar Lantik</b-col>
                        <b-col lg='1'>:</b-col>
                        <b-col lg='6'>
                            <b-form-input v-model="Obj.SalAmt" :state="getValidation(validationContext)" style="width: 80%"></b-form-input>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="AmaunTelahTerima" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col lg='3'>Amaun Dalam Buku Servis:</b-col>
                        <b-col lg='1'>:</b-col>
                        <b-col lg='6'>
                            <b-form-input v-model="Obj.AmaunTelahTerima" :state="getValidation(validationContext)" style="width: 80%"></b-form-input>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Tarikh Pergerakan Gaji" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col sm="3"> Tarikh Pergerakan Gaji (TPG)</b-col>
                        <b-col sm="1">:</b-col>
                        <b-col sm="6">
                            <b-form-select id="Tarikh Pergerakan Gaji (TPG)" name="Tarikh Pergerakan Gaji (TPG)" value-field="value" text-field="text" v-model="Obj.TPGid" :options="tpgList" style="width: 60%" aria-describedby="input-2-live-feedback">
                                <template #first>
                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Tarikh Kuatkuasa" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col lg='3'>Tarikh Kuatkuasa </b-col>
                        <b-col lg='1'>:</b-col>
                        <b-col lg='4'>
                            <base-input type="date" v-model="Obj.EftDate" />

                        </b-col>
                    </b-row>
                </validation-provider>
                <validation-provider name="Catatan" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col lg='3'>Catatan</b-col>
                        <b-col lg='1'>:</b-col>
                        <b-col lg='6'>
                            <b-form-textarea v-model="Obj.Catatan" class="custom-input" rows="4" maxlength="1000" placeholder="Masukkan catatan (maksimum 1000 aksara)"></b-form-textarea>
                        </b-col>
                    </b-row>
                </validation-provider>
                <b-col>&nbsp;</b-col>
                <b-form-row>
                    <b-col>
                        <b-form-group>
                            <div>
                                <b-col>&nbsp;</b-col>
                                <b-col align="center">
                                    <b-button variant="success" type="submit">SIMPAN</b-button>
                                    <b-button size="md" variant="danger" @click="batal()">BATAL</b-button>

                                </b-col>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </div>
        </b-form>
    </validation-observer>
</div>
</template>

<script>
import moment from "moment";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
import swal from "sweetalert2";
export default {
    props: ["tahun", "elemenId"],
    data() {
        return {

            Obj: {
                Catatan: `Dilantik sebagai <NAMA JAWATAN> Gred <GRED>`,
            },
            ServClassList: [],
            SchmOfServList: [],
            SalGrdList: [],
            tpgList: [],
            skimOptions: [{
                    value: '2',
                    text: 'SSPA'
                },
                {
                    value: '1',
                    text: 'SSM'
                },
            ],
        }
    },
    methods: {
        getValidation({
            dirty,
            validated,
            valid = null
        }) {

            return dirty || validated ? valid : null;
        },
        runMethod() {
            console.log(this.ServClassId);

            let Search = {
                ServClassId: this.Obj.ServClassId,
            };

            GetselenggaraService.getSenaraiSchmOfServ(Search)
                .then((resp) => {
                    this.SchmOfServList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        runMethod2() {
            console.log("this SchmOfServId", this.SchmOfServId);
            let Search2 = {
                ServClassId: this.Obj.ServClassId,
                SchmOfServId: this.Obj.SchmOfServId,
                pilihSkim: this.Obj.id_SistemSaraan,
            };
            console.log("this Search2", this.Search2);
            GetselenggaraService.getSenaraiSalGrd(Search2)
                .then((resp) => {
                    this.SalGrdList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        SimpanMaklumat() {
            this.Obj.coid = Store.state.MaklumatPeribadi.coid;
            this.Obj.tahun = this.tahun;
            this.Obj.elemenId = this.elemenId;
            console.log("log", this.Obj);

            GetsalaryService.setElemenTukarLantik(this.Obj).then((resp) => {
                this.StatusSimpan = resp.data;
            }).then(() => {

                console.log("StatusSimpan", this.StatusSimpan);

                if (this.StatusSimpan.Status == 1) {
                    swal
                        .fire({
                            title: "BERJAYA DI SIMPAN!",
                            text: "CLICK OK UNTUK TERUSKAN.",
                            icon: "success",
                        })
                        .then(() => {
                            this.$emit("batal");
                        });
                } else {
                    swal.fire({
                        title: this.StatusSimpan.details,
                        text: "CLICK OK UNTUK TERUSKAN.",
                        icon: "error",
                    }).then(() => {
                        this.$emit("batal");
                    });
                }
            });
        }
    },
    created() {

        GetselenggaraService.getSenaraiServClass()
            .then((resp) => {
                this.ServClassList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

        GetselenggaraService.getTPG()
            .then((resp) => {
                this.tpgList = resp.data;
                console.log("tpgList", this.tpgList);
            })
            .catch((err) => {
                console.log(err);
            });
    }
}
</script>
